import { textStyles as i } from "../../textStyles.es.js";
import { defineStyleConfig as e, defineStyle as r } from "@chakra-ui/react";
const t = e({
  baseStyle: r({
    display: "inline-flex",
    alignItems: "center",
    cursor: "pointer",
    gap: "spacing-25",
    _disabled: {
      pointerEvents: "none"
    },
    _hover: {
      textDecoration: "underline"
    }
  }),
  variants: {
    universal: {
      color: "link.default",
      _disabled: {
        color: "link.disabled"
      },
      _hover: {
        color: "link.hover"
      },
      _active: {
        color: "link.visited"
      }
    },
    primary: {
      _light: {
        color: "primary.700",
        _disabled: {
          color: "primary.100"
        },
        _hover: {
          color: "primary.700"
        },
        _active: {
          color: "primary.900"
        }
      },
      _dark: {
        color: "primary.0",
        _disabled: {
          color: "primary.500"
        },
        _hover: {
          color: "primary.300"
        },
        _active: {
          color: "primary.100"
        }
      },
      _hover: {
        textDecorationColor: "secondary.500"
      }
    }
  },
  sizes: {
    xxl: {
      ...i.xxl,
      "& > svg": {
        width: "size-300",
        height: "size-300"
      }
    },
    xl: {
      ...i.xl,
      "& > svg": {
        width: "size-250",
        height: "size-250"
      }
    },
    lg: {
      ...i.lg,
      "& > svg": {
        width: "size-200",
        height: "size-200"
      }
    },
    md: {
      ...i.md,
      "& > svg": {
        width: "size-175",
        height: "size-175"
      }
    },
    sm: {
      ...i.sm,
      "& > svg": {
        width: "size-150",
        height: "size-150"
      }
    }
  },
  defaultProps: {
    variant: "universal",
    size: "md"
  }
});
export {
  t as TextLink
};
//# sourceMappingURL=TextLink.es.js.map
